import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="Footer">
      제작: 강익치 <br />
      문의: 010-8321-9409 <br />
      <strong> 버그 및 추가기능 요청시 문의정보로 연락 요망.</strong>
    </footer>
  );
};

export default Footer;
